/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from "vue-tsx-support";
import {Component} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import _ from 'lodash'
import './layout.less';
import Head from './components/head';

@Component
export default class Layout extends Vue.Component<any> {


	render (h) {
		return (
			<div class="wqms-layout-wrapper">
				<Head></Head>
                <div class="wqms-content-wrapper">
                    <router-view key={this.$route.params.type||this.$route.meta.key}></router-view>
                </div>
			</div>
		);
	}
}
